import React, { useState } from 'react';
import './Bookings.css';

const Bookings = () => {
  const [filter, setFilter] = useState('all');

  // بيانات وهمية للعرض فقط
  const [bookings] = useState([
    {
      id: 1,
      billboardTitle: 'Premium Downtown Billboard',
      clientName: 'Ahmed Mohamed',
      clientEmail: 'ahmed@example.com',
      clientPhone: '+201234567890',
      startDate: '2024-02-01',
      endDate: '2024-03-01',
      totalAmount: 2500,
      status: 'pending'
    },
    {
      id: 2,
      billboardTitle: 'City Center Digital',
      clientName: 'Sarah Johnson',
      clientEmail: 'sarah@company.com',
      clientPhone: '+201112223333',
      startDate: '2024-01-20',
      endDate: '2024-02-20',
      totalAmount: 4200,
      status: 'approved'
    },
    {
      id: 3,
      billboardTitle: 'Highway Static Board',
      clientName: 'Mohamed Ali',
      clientEmail: 'mohamed.ali@business.com',
      clientPhone: '+201556667777',
      startDate: '2024-01-15',
      endDate: '2024-04-15',
      totalAmount: 5400,
      status: 'completed'
    }
  ]);

  const updateBookingStatus = (id, status) => {
    alert(`Booking ${id} status would be updated to ${status} (API not connected)`);
  };

  const filteredBookings = filter === 'all' 
    ? bookings 
    : bookings.filter(booking => booking.status === filter);

  return (
    <div className="bookings-page">
      <div className="page-header">
        <h1>Bookings Management</h1>
        <div className="header-actions">
          <select 
            value={filter} 
            onChange={(e) => setFilter(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Bookings</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="completed">Completed</option>
          </select>
          <button className="refresh-btn">
            🔄 Refresh
          </button>
        </div>
      </div>

      <div className="bookings-container">
        {filteredBookings.length === 0 ? (
          <div className="no-bookings">
            <p>No bookings found</p>
          </div>
        ) : (
          <div className="bookings-grid">
            {filteredBookings.map(booking => (
              <div key={booking.id} className="booking-card">
                <div className="booking-header">
                  <h3>{booking.billboardTitle}</h3>
                  <span className={`status status-${booking.status}`}>
                    {booking.status}
                  </span>
                </div>

                <div className="booking-details">
                  <p><strong>Client:</strong> {booking.clientName}</p>
                  <p><strong>Email:</strong> {booking.clientEmail}</p>
                  <p><strong>Phone:</strong> {booking.clientPhone}</p>
                  <p><strong>Period:</strong> {new Date(booking.startDate).toLocaleDateString()} - {new Date(booking.endDate).toLocaleDateString()}</p>
                  <p><strong>Total:</strong> ${booking.totalAmount}</p>
                </div>

                {booking.status === 'pending' && (
                  <div className="booking-actions">
                    <button 
                      onClick={() => updateBookingStatus(booking.id, 'approved')}
                      className="action-btn approve-btn"
                    >
                      Approve
                    </button>
                    <button 
                      onClick={() => updateBookingStatus(booking.id, 'rejected')}
                      className="action-btn reject-btn"
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Bookings;